<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        refreshing: false,
        registration: null,
        isevent: false,
        openevent: false,
        updateExists: false,
        isRouterAlive: true,
      }
    },
    methods: {
      showRefreshUI(e) {
        // Display a button inviting the user to refresh/reload the app due
        // to an app update being available.
        // The new service worker is installed, but not yet active.
        // Store the ServiceWorkerRegistration instance for later use.
        this.registration = e.detail;
        this.updateExists = true;
        if (this.updateExists) {
          this.refreshApp();
        }
        // this.registration.waiting.postMessage("refresh");
        console.log("refresh");
      },
      refreshApp() {
        // Handle a user tap on the update app button.
        this.updateExists = false;
        // Protect against missing registration.waiting.
        if (!this.registration || !this.registration.waiting) {
          console.log("New.");
          return;
        }
        this.registration.waiting.postMessage("skipWaiting");
      }
    },
    created() {
      document.addEventListener("swUpdated", this.showRefreshUI, {
        once: true
      });
      // Refresh all open app tabs when a new service worker is installed.
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      });
    }
  }

</script>
<style lang="scss">
  // #app {
  //   font-family: 'Avenir', Helvetica, Arial, sans-serif;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   text-align: center;
  //   color: #2c3e50;
  // }

  // #nav {
  //   padding: 30px;

  //   a {
  //     font-weight: bold;
  //     color: #2c3e50;

  //     &.router-link-exact-active {
  //       color: #42b983;
  //     }
  //   }
  // }

</style>
